<template>
	<div class="page-content">
		<div class="page-top-menu" style='background:#fff;padding:0;'>
			<div class="start">
				필터링
			</div>
			<i class="fa fa-times"  @click="$router.go(-1)"></i>
			
		</div>
		<div class="data-content">
			<!--div class="box-list-1">
			     <select v-model="gtype">
					<option value="">시험 선택</option>
					<option v-for="name,code in gtypeList" :value="code" >{{name}}</option>
				 </select>
			</div-->
			<div class="categoryList" >
				<ul v-if="categorys.length>0">
					<li v-for="data,index in categorys">
						<div class="img-box" @click="goSearch(data.no,data.name)">
							<img :src="$VARS.url+data.img"/>
						</div>
						<div class="game-box"  @click="goSearch(data.no,data.name)">
							<div class="subject">{{data.name}}</div>
							<div class="summary" v-html="data.content"></div>
						</div>
						<i v-if="!data.favorite" class="far fa-star" @click="setFavorite(index,'yes')"></i>
						<i v-else class="fas fa-star"  @click="setFavorite(index,'no')"></i>
					</li>
				</ul>	
				<div v-if="categorys.length<1 && resultView" class="noitemBox">
					<h3>검색결과가 존재하지 않습니다</h3>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
export default {
	name: 'ProblemSearch',
	watch: {
		gtype(val) {
			this.searchCategory(val);
		}
	},
	data() {
		return {
			categorys:[],
			gtype:'',
			gtypeList:{},
			resultView:false,
		}
	},
	created() {
		sessionStorage.setItem('compNo','');
		sessionStorage.setItem('compName','');
		this.getData()
	},
    methods: {
       getData() {
		    var obj = this;
			this.$form.sendPost({gtype:this.gtype},'problem/getCompanyList',function(resp) {
				obj.categorys = resp.companyList;
				obj.gtypeList = resp.gtypeList;
			},'multi');
		},
		goSearch(no,name) {
			sessionStorage.setItem('compNo',no);
			sessionStorage.setItem('compName',name);			
			this.$router.go(-1);
		},
		setFavorite(index,cmd) {
			var item = this.categorys[index];
			
			if(cmd=='yes') {
				
				item.favorite='yes';
			} else {
				item.favorite='';
			}
			var obj = this;
			this.$form.sendPost({no:item.no,cmd:cmd},'problemProc/setCompanyFavorite',function(resp) {
				obj.$set(obj.categorys,index,item);
			});
			
		},
		searchCategory(code) {
			this.gtype = code;
			this.getData();
		}
			
    },
	mounted() {
	},
	updated() {
		
	},
	
}
</script>

<style lang="scss" scoped>
.page-content {
	background:#fff;
	width:780px;
	max-height:500px;
}
.page-top-menu {
	position:relative;
	width:100%;
	height:55px;
	border-bottom:solid 2px #ccc;
	.start {
		width:100%;
		height:55px;
		line-height:55px;
		text-align:center;
		font-weight:bold;
		color:#000;
		font-size:13pt;
	}
	i {
		color:#000;
		font-size:13pt;
		position:absolute;
		top:19px;
		right:15px;
		cursor:pointer;
	}
	
}
.data-content {
	padding:0;
	margin:0;
	background:#E6E8F4;
	height:480px;
	overflow-y:auto;
	overflow-x:hidden;
	max-width:780px;
	.box-list-1 {
		padding:20px 40px 0 40px;
		select {
			width:335px;
			height:35px;
			background:#fff;
			border-radius:10px;
			padding-left:20px;
			border:solid 1px #ccc;
		}
	}
	.categoryList {
		padding:0 20px 10px 20px;
		margin:10px 20px 20px 20px;
		.noitemBox {
			padding-top:90px;
			text-align:center;
		}
		ul {
			width:740px;
			display:flex;
			flex-wrap:wrap;
			li {
				width:335px;
				display:flex;
				height:100px;
				background:#fff;
				margin-top:10px;
				.img-box {
					margin:10px 0 0 20px;
					width:55px;
					height:55px;
					line-height:50px;
					border-radius:50%;
					border:1px solid #E7E7E7;
					text-align:center;
					overflow:hidden;
					cursor:pointer;
					img {
					 width:100%;
					 min-height:55px;
					}
				}
				.game-box {
					text-align:left;
					width:250px;
					padding:10px 0 0 20px;
					color:#000;
					font-size:13pt;
					font-weight:bold;
					cursor:pointer;
					.summary {
						color:#999;
						font-size:10pt;
						font-weight:normal;
						padding-top:10px;
						line-height:120%;
					
					}
					
				}
				i {
					font-size:13pt;
					margin-right:5px;
					cursor:pointer;
				}
				i.fas {
					color:#FFC600;
				}
				
				&:nth-child(2n-1) {
					margin-right:30px;
				}
				
			}
		}
	}
}
</style>